/* Promo cards (final): bottom wrapper so CTA sits above, toggle is very bottom
   - Mobile (<=1120px): bullets 3..N collapse; CTA hidden until expanded; toggle bottom-most
   - Desktop: expanded, toggle hidden
*/
(function () {
  let uid = 0;

  const I18N = Object.assign({
    readMore: 'Read more',
    readLess: 'Show less'
  }, (window.promocards_i18n || {}));

  function injectStylesOnce() {
    if (document.getElementById('p4-readmore-styles')) return;
    const css = `
      .module__promocards .p4-more{overflow:hidden;max-height:0;transition:max-height .35s ease;}
      .module__promocards .p4-toggle{
        background:none;border:0;padding:0;margin:12px 0 0;
        font-weight:800;font-size:20px;line-height:1;cursor:pointer;
        display:inline-flex;gap:10px;align-items:center;
        text-decoration:none;color:#262626;
      }
      .module__promocards .p4-toggle:focus{outline:2px solid rgba(117,183,38,.4);outline-offset:2px;}
      .module__promocards .p4-toggle svg{width:24px;height:24px;transition:transform .2s ease;}
      .module__promocards .p4-toggle .arrow path{
        fill:none;stroke:#75B726;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;
      }
      .module__promocards .p4-toggle[aria-expanded="true"] .arrow{transform:rotate(180deg);}

      /* New: bottom wrapper that sticks to bottom of content */
      .module__promocards .p4-bottom{display:flex;flex-direction:column;gap:10px;}
      .module__promocards .p4-bottom .p4-cta{margin-top:0 !important;} /* override theme pushing CTA down inside this wrap */

      /* Desktop: always expanded, hide toggle */
      @media (min-width:1121px){
        .module__promocards .p4-toggle{display:none !important;}
        .module__promocards .p4-more{max-height:none !important;overflow:visible !important;}
        .module__promocards .p4-bottom{margin-top:auto;} /* pin CTA to bottom on desktop too */
      }

      /* Mobile helpers */
      @media (max-width:1120px){
        .module__promocards .p4-content{display:flex;flex-direction:column;}
        .module__promocards .p4-bottom{margin-top:auto;align-items:center;} /* keep group at the very bottom */
        .module__promocards .p4-content.is-collapsed .p4-bottom .p4-cta{display:none;} /* CTA hidden until expanded */
      }
    `;
    const tag = document.createElement('style');
    tag.id = 'p4-readmore-styles';
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  function expand(el) {
    if (el.style.maxHeight === 'none') return;
    el.style.maxHeight = el.scrollHeight + 'px';
    const onEnd = (e) => {
      if (e.propertyName !== 'max-height') return;
      el.style.maxHeight = 'none';
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('transitionend', onEnd);
  }
  function collapse(el) {
    if (el.style.maxHeight === 'none') {
      el.style.maxHeight = el.scrollHeight + 'px';
      void el.offsetHeight;
    }
    el.style.maxHeight = '0px';
  }

  function setupCard(card) {
    const content = card.querySelector('.p4-content');
    if (!content) return;

    const list = content.querySelector('.p4-list');
    const cta  = content.querySelector('.p4-cta');
    if (!list) return;

    const items = Array.prototype.slice.call(list.children)
      .filter(n => n.classList && n.classList.contains('p4-li'));

    if (items.length <= 2) return;

    const more = document.createElement('div');
    more.className = 'p4-more';
    more.id = 'p4more-' + (++uid);
    items[1].insertAdjacentElement('afterend', more);
    items.slice(2).forEach(el => more.appendChild(el));

    const bottom = document.createElement('div');
    bottom.className = 'p4-bottom';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'p4-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', more.id);
    toggle.innerHTML = `
      <span class="p4-toggle-text">${I18N.readMore}</span>
      <svg class="arrow" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 8 L12 16 L20 8"></path>
      </svg>
    `;

    if (cta) bottom.appendChild(cta);
    bottom.appendChild(toggle);
    content.appendChild(bottom);

    // Start collapsed on mobile
    content.classList.add('is-collapsed');

    let open = false;
    toggle.addEventListener('click', () => {
      open = !open;
      if (open) {
        expand(more);
        toggle.setAttribute('aria-expanded', 'true');
        toggle.querySelector('.p4-toggle-text').textContent = I18N.readLess;
        content.classList.remove('is-collapsed');
      } else {
        collapse(more);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.querySelector('.p4-toggle-text').textContent = I18N.readMore;
        content.classList.add('is-collapsed');
      }
    });

    // Responsive switch
    const mq = window.matchMedia('(min-width:1121px)');
    function onMQ(e){
      if (e.matches){ // desktop
        more.style.maxHeight = 'none';
        content.classList.remove('is-collapsed');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.querySelector('.p4-toggle-text').textContent = I18N.readLess;
      } else { // mobile
        if (!open){
          more.style.maxHeight = '0px';
          content.classList.add('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.querySelector('.p4-toggle-text').textContent = I18N.readMore;
        }
      }
    }
    mq.addEventListener ? mq.addEventListener('change', onMQ) : mq.addListener(onMQ);
    onMQ(mq);
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectStylesOnce();
    document.querySelectorAll('.module__promocards .p4-card').forEach(setupCard);
  });
})();
